var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "fill-place" }, [
    _c("div", { staticClass: "person-info person-info--preview" }, [
      _c(
        "div",
        {
          staticClass: "person-info__content",
          class: { _error: _setup.shouldShowError },
        },
        [
          _c("div", { staticClass: "person-info__booking" }, [
            _vm._v(
              "\n                " +
                _vm._s(_setup.place_label) +
                "\n            "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "person-info__service-icon" },
            [
              _setup.shouldShowError
                ? _c(_setup.vWarning, { staticClass: "icon vicon-orange" })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "person-info__name" }, [
            _vm._v(
              "\n                " +
                _vm._s(_setup.person_names.fio || "[Заполните ФИО]") +
                "\n            "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "person-info__sign" }, [
            _vm._v(
              "\n                " +
                _vm._s(
                  _setup.person_names.born || "[Заполните Дату рождения]"
                ) +
                ", " +
                _vm._s(_setup.person_names.male || "[Заполните Пол]") +
                "\n            "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "person-info__docs" }, [
            _c(
              "div",
              { staticClass: "person-info__docs-icon" },
              [_c(_setup.docIcon, { tag: "component" })],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "person-info__docs-type" }, [
              _vm._v(
                _vm._s(_setup.person_names.doc_type || "[Заполните Документ]")
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "person-info__docs-num" }, [
              _vm._v(
                _vm._s(_setup.person_names.doc_num || "[Заполните Серию Номер]")
              ),
            ]),
          ]),
          _vm._v(" "),
          _setup.person_names.extraFields.length
            ? _c(
                "div",
                { staticClass: "person-info__extra" },
                _vm._l(_setup.person_names.extraFields, function (field) {
                  return _c(
                    "div",
                    { key: field.name, staticClass: "person-info__extra-row" },
                    [
                      _c("span", { staticClass: "person-info__extra-label" }, [
                        _vm._v(_vm._s(field.title) + ":"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "person-info__extra-value" }, [
                        _vm._v(_vm._s(field.val)),
                      ]),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _setup.shouldShowError
        ? _c("div", { staticClass: "person-info__errors" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _setup.person_names.isValid
                    ? "Корректно"
                    : "Вернитесь и заполните всю информацию"
                ) +
                "\n        "
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }